import { api } from "@/lib/api";
import { IAHJ, AHJFormData } from "@/types/ahj";

export interface GetAHJsResponse {
  ahjs: IAHJ[];
}

export interface GetAHJResponse {
  ahj: IAHJ;
}

export interface CreateAHJResponse {
  ahj: IAHJ;
}

export interface UpdateAHJResponse {
  ahj: IAHJ;
}

export interface DeleteAHJResponse {
  message: string;
}

export const ahjApi = {
  // Get all AHJs with optional filters
  getAHJs: async (params?: {
    state?: string;
    type?: string;
    search?: string;
  }): Promise<GetAHJsResponse> => {
    const queryParams = new URLSearchParams();
    if (params?.state) queryParams.append("state", params.state);
    if (params?.type) queryParams.append("type", params.type);
    if (params?.search) queryParams.append("search", params.search);

    const url = `/ahjs${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    const response = await api.get<GetAHJsResponse>(url);
    return response.data;
  },

  // Get single AHJ by ID
  getAHJ: async (id: string): Promise<GetAHJResponse> => {
    const response = await api.get<GetAHJResponse>(`/ahjs/${id}`);
    return response.data;
  },

  // Create new AHJ
  createAHJ: async (data: AHJFormData): Promise<CreateAHJResponse> => {
    const response = await api.post<CreateAHJResponse>("/ahjs", data);
    return response.data;
  },

  // Update AHJ
  updateAHJ: async (
    id: string,
    data: Partial<AHJFormData>
  ): Promise<UpdateAHJResponse> => {
    const response = await api.put<UpdateAHJResponse>(`/ahjs/${id}`, data);
    return response.data;
  },

  // Delete AHJ
  deleteAHJ: async (id: string): Promise<DeleteAHJResponse> => {
    const response = await api.delete<DeleteAHJResponse>(`/ahjs/${id}`);
    return response.data;
  },
};
